<template>
  <div class="news">
    <transition name="fade">
      <div class="new-fixed" v-show="isNewsBlock" @click="isNewsBlock = false"></div>
    </transition>
    <span class="width-icon" :style="[
      source ? 'height:43px;padding-top:7px;' : '',
      {
        lineHeight: layout === '1' ? 'initail' : 'initail',
      },
    ]" @click="newFun">
      <i class="iconfont icon-shouye-gaozhiwode icon-news" :style="{ color: iconColor }">
      </i>
      <i class="icon-news-number" v-show="count > 0">{{
        count > 99 ? "99+" : count
      }}</i>
    </span>
    <span class="news-title" v-show="isNews && count > 0">
      <i class="el-icon-caret-top news-title-caret-top"></i>
      你有{{ count }}条新消息，
      <span class="cor-b00 hover-view" @click="viewNews">点击查看</span>
      <i class="iconfont icon-shanchu3 icon-close" @click="closeNews"></i>
    </span>
    <div class="news-block">
      <el-collapse-transition>
        <div class="news-block-block" v-show="isNewsBlock">
          <div class="click-mom" v-if="newsList.length === 0">暂无消息</div>

          <div class="title-news" v-show="count > 0">
            <span>{{ count }}条消息未读</span>
            <span class="readed" @click="alReady">全部标记已读</span>
          </div>
          <div class="news-scrollbar" v-if="newsList.length > 0" :style="newsList.length > 5 ? '' : 'height: auto;'">
            <el-scrollbar :style="newsList.length > 5
                ? 'height: 100%;'
                : 'height: 100%;padding-bottom: 16px;'
              " v-loadmore="loadmore">
              <div class="news-list" v-for="(list, index) in newsList" :key="index" @click="lookInfo(list, index)"
                :style="Number(list.status) === 1 ? 'opacity:0.5;' : ''">
                <span class="news-list-left" :style="statusArr[list.type]">
                  <i :class="'icon-size ' + typeArr[list.type]"></i>
                </span>
                <div class="news-list-right">
                  <div class="news-title-name ellipsisTwo">
                    {{ list.title }}
                  </div>
                  <div class="new-title-time">提交时间：{{ formatDate(list.ctime) }}</div>
                  <div class="new-title-time">{{ list.content }}</div>
                </div>
              </div>
              <div class="click-mom" v-show="count > 5">
                {{ loading ? "加载中..." : "没有更多了" }}
              </div>
            </el-scrollbar>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <oaExamineAudit ref="AuditOpenChild" class="oa-examine-audit"></oaExamineAudit>
    <div id="news"></div>
  </div>
</template>

<script>
import oaExamineAudit from '@/components/clientSide/oaExamineAudit.vue'
import { openapiGetusermessagelist, openapiGetunreadmessagecount, openapiUpdateusermessage, batchusermessageread } from '@/port/common/schoolNews'
import { formatDate } from '@/api/global'
export default {
  name: "schoolNews",
  props: ['source', 'iconColor', 'layout'],
  components: {
    oaExamineAudit
  },
  data() {
    return {
      isNews: false,
      isNewsBlock: false,
      loading: false,
      newsList: [], // type 0 待办 1 已通过 2 拒绝  status 0 未读 1 已读
      websock: null,
      websockCountClose: 6,
      websockLoginCount: 6,
      websockSetTime: null,
      page: {
        pagesize: 10,
        curpage: 1
      },
      total: 0,
      count: 0,
      typeArr: ['icon-chulizhong-', 'el-icon-check', 'el-icon-close', 'el-icon-more'],
      statusArr: ['background:#F5AD00;', 'background:#19B359;', 'background:#D44C4C', 'background:#2086DA;']
    }
  },
  //自定义指令
  directives: {
    'loadmore': {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector('.el-scrollbar__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          const condition = this.scrollHeight - (this.scrollTop + 50) <= this.clientHeight;
          if (condition) {
            console.log(binding.value());
            binding.value();
          }
        });
      }
    }
  },
  // created() {
  //   this.getCountn();
  //   this.getList();
  // },
  watch: {
    '$store.state.isNewsCount'(val) {
      if (val) {
        this.page.curpage = 1;
        localStorage.removeItem('isNews');
        let self = this;
        clearTimeout(this.websockSetTime);
        this.websockSetTime = null;
        this.websockSetTime = setTimeout(function () {
          self.getCountn();
        }, 1000);
      }
    },
    isNewsBlock(val) {
      if (!val) {
        try {
          document.querySelector('.news-scrollbar .el-scrollbar__wrap').scrollTop = 0;
        }
        catch (e) { console.log(e) }
      }
    }
  },
  mounted() {
    this.getCountn();
    this.getList();
    let str = '<style>' +
      '.news-scrollbar .el-scrollbar__wrap {overflow-x: hidden;}' +
      '</style>';
    try {
      document.getElementById('news').innerHTML = str;
    }
    catch (error) {
      return
    }
  },
  methods: {
    formatDate(time) {
      //时间戳转成时间
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm"); //yyyy-MM-dd hh:mm
    },
    async alReady() {
      this.count = 0
      this.newsList.forEach(item => {
        item.status = 1
      })
      await batchusermessageread()
    },
    closeNews() {
      this.isNews = false;
      localStorage.setItem('isNews', this.count);
    },
    loadmore() {
      if (this.newsList.length >= this.total || this.loading) {
        return false;
      }
      this.page.curpage += 1;
      this.getList();
    },
    lookInfo(val, index) {
      console.log('查看', val)
      if (Number(val.status) === 0) this.newStatus(val, index);
      let date = {
        approving: {
          approvingId: val.approvingId,
          approvalId: val.appId
        },
        userapprovingId: val.userapprovingId
      };
      this.$refs.AuditOpenChild.AuditOpenList(date);
    },
    newStatus(val, index) {
      openapiUpdateusermessage({
        messageId: val.messageId,
        status: 1
      }).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.newsList[index].status = 1;
          this.count -= 1;
          localStorage.setItem('isNews', this.count);
        }
      }).catch(error => { console.log(error) })
    },
    newFun() {
      this.isNews = false;
      if (!this.isNewsBlock) {
        this.isNewsBlock = true;
        this.page.curpage = 1;
        this.getList(1);
      } else {
        this.isNewsBlock = false;
      }
    },
    getCountn() {
      if (this.$route.params.skey || this.$route.query.skey) {
        return
      }
      openapiGetunreadmessagecount().then(res => {
        console.log('原点计数', res)
        if (res.code === 0) {
          this.count = res.data;
          let isNewsLocal = localStorage.getItem('isNews');
          if (!isNewsLocal || isNewsLocal < res.data) {
            this.isNews = true;
            this.$store.commit('upNewsCount', false);
          }
        }
      }).catch(error => { console.log(error) })
    },
    getList(e) {
      this.loading = true;
      if (this.$route.params.skey || this.$route.query.skey) {
        return
      }
      openapiGetusermessagelist(this.page).then(res => {
        //type:1同意2退回3评论，content内容或自定义标题
        console.log('列表数据获取', res)
        if (res.code === 0) {
          if (e) {
            this.newsList = res.data;
          } else {
            this.newsList = this.newsList.concat(res.data);
          }
          this.total = res.total;
          this.loadmore();
        }
        this.loading = false;
      }).catch(error => { console.log(error) })
    },
    viewNews() {
      this.isNews = false;
      localStorage.setItem('isNews', this.count);
      this.newFun();
    },
  }
}
</script>

<style>
.news .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.news .fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
<style lang="scss" scoped>
.new-fixed {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.oa-examine-audit {
  line-height: normal;
}

.icon-size {
  font-size: 8px;
}

.news-list {
  display: flex;
  align-items: self-start;
  padding: 9px 0px;
  margin: 0 12px;
  border-bottom: 1px solid #e9e9e9;
  cursor: pointer;
}

.news-list:hover {
  background: #f1f8ff;
}

.news-list-left {
  width: 16px;
  height: 16px;
  text-align: center;
  display: block;
  margin: 2px 8px 0 0;
  line-height: 16px;
  color: #ffffff;
  border-radius: 50%;
  -webkit-border-radius: 50%;
}

.news-list-right {
  line-height: 60px;
  max-width: 224px;
  text-align: left;
}

.news-title-name {
  font-size: 14px;
  color: #333333;
  line-height: 18px;
  margin-bottom: 5px;
}

.new-title-time {
  line-height: 16px;
  font-size: 12px;
  color: #999999;
}

.click-mom {
  font-size: 12px;
  color: #666666;
  line-height: 35px;
  text-align: center;
  border-top: 1px solid #e9e9e9;
}

.news-scrollbar {
  height: 298px;
}

.icon-close {
  font-size: 9px;
  margin-left: 9px;
  cursor: pointer;
}

.title-news {
  font-size: 14px;
  color: #333333;
  padding: 0 24px;
  height: 40px;
  text-align: left;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .readed {
    border: solid 1px #333333;
    border-radius: 4px;
    height: 24px;
    line-height: 24px;
    padding: 0 10px;

    &:hover {
      border-color: #4e86ff;
      color: #4e86ff;
      cursor: pointer;
    }
  }
}

.cor-b00 {
  color: #4e86ff;
  cursor: pointer;
}

.news-block {
  width: 312px;
  /*height: 347px;*/
  position: absolute;
  z-index: 2000;
  left: 14%;
  top: 50px;
  transform: translateX(-50%);
}

.news-block-block {
  background: #ffffff;
  border: 1px solid #eeeeee;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  box-shadow: 0px 2px 8px 0px rgba(229, 229, 229, 0.31);
}

.news {
  position: relative;
  display: inline-block;
  width: 70px;
  height: 100%;
}

.news-title {
  position: absolute;
  top: 63px;
  display: flex;
  width: 200px;
  z-index: 1900;
  right: 0;
  background: #505050;
  color: #ffffff;
  line-height: 40px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  font-size: 12px;
  align-items: center;
  justify-content: center;
}

.news-title-caret-top {
  position: absolute;
  right: 22px;
  top: -7px;
  color: #505050;
}

.icon-news {
  font-size: 22px;
  color: #333333;
  position: relative;
}

.icon-news-number {
  position: absolute;
  background: #ef6448;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
  top: 7px;
  left: 24px;
  line-height: 18px;
  padding-left: 5px;
  padding-right: 5px;
  color: #ffffff;
  font-size: 12px;
}

.width-icon {
  width: 56px;
  display: inline-block;
  text-align: center;
  // height: 59px;
  height: 100%;
  position: relative;
  z-index: 99;
  cursor: pointer;
}

.width-icon:hover .icon-news {
  color: #4e86ff;
}

.hover-view:hover {
  color: #71b7ff;
}
</style>
